// extracted by mini-css-extract-plugin
module.exports = {"header-fixed":"e2ff468f85--header-fixed--2YeeW","adaptive-header":"e2ff468f85--adaptive-header--2tCNU"};